<template>
  <div class="registerFloat alone-style">
    <dialogTem 
    :visible.sync="showloginfloat" 
    :types="'signup'"
    :diaWidth="'800px'"
    :diaTitle="$t('header.signup')"
    @handleCloseDialog="()=>setshowloginfloat(false)" >
      <!-- 注册内容 -->
      <div class="login-body" v-if="!isLogin">
        <div class="box-left">
          <el-form
            class="form-horizontal newform"
            ref="ruleForm"
            label-width="100px"
            :model="user"
            :rules="rules"
            label-position="top"
          >
          <!-- 用户名 -->
          <el-form-item prop="username" v-if="isPhoneVerify != '3'">
            <div :class="{'signUpStyle':changeSyle.regsStatus,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('header.user')}}
            </div>
            <el-input type="text" v-model="user.username" 
            autocomplete="off" :max="12" :disabled="isReady"
            :placeholder="changeSyle.regsStatus ? $t('register.userPlace') : '' " 
            @keyup.enter.native="submitForm('ruleForm')"  
            @focus="handleFocus(user.username,'regsStatus')" 
            @blur="handleBlur(user.username,'regsStatus')" class="icon_username">
            </el-input>
          </el-form-item>
          <!-- 手机号注册 -->
          <el-form-item prop="phone" class="phone" v-else>
            <div :class="{'signUpStyle':changeSyle.regsStatus,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('register.phone')}}
            </div>
            <el-input type="text" v-model="user.phone" 
            autocomplete="off" :max="12" :disabled="sending || isReady"
            :placeholder="changeSyle['phone'] ? $t('verificationRegister')['phone'] : '' " 
            @keyup.enter.native="submitForm('ruleForm')"  
            @focus="handleFocus(user.phone,'regsStatus')"
            @blur="handleBlur(user.phone,'regsStatus')">
              <span  slot="prefix" >+91</span>
              <!-- <template  slot="suffix" :class="{'disabled':sending}">
                  <el-button round @click.native="sendCode" :disabled="sending">{{$t(sendingTip)}}</el-button>
              </template> -->
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <div :class="{'signUpStyle':changeSyle.regsStatus01,signupComlabel:true}">
              <span class="tips">*</span>
               {{ hasSendPhoneCode == '1' ? $t('mine.safein.vipTitle') : $t('header.password')}}
            </div>
            <el-input :type="flag ? 'password':'text'" v-model="user.password" autocomplete="off" :max="12"
            :placeholder="changeSyle.regsStatus01 ? $t('register.userPlace') : '' " 
            @keyup.enter="submitForm('ruleForm')" :disabled="isReady"
            @focus="handleFocus(user.password,'regsStatus01')" 
            @blur="handleBlur(user.password,'regsStatus01')" class="icon_password">
            <i slot="suffix" :class="flag ? 'close_eye':'el-icon-view'" autocomplete="auto" @click="flag=!flag" />
            </el-input>
          </el-form-item>

          <el-form-item prop="repeatPassword" v-if="hasSendPhoneCode != '1'">
            <div :class="{'signUpStyle':changeSyle.regsStatus02,signupComlabel:true}">
              <span class="tips">*</span>
              {{$t('register.ConfirmPassword')}}
            </div>
            <el-input :type="repertFlag ? 'password':'text'" v-model="user.repeatPassword" autocomplete="off" 
            :placeholder="changeSyle.regsStatus02 ? $t('register.passwordPlace') : '' "
            @keyup.enter.native="submitForm('ruleForm')" :disabled="isReady"
            @focus="handleFocus(user.repeatPassword,'regsStatus02')" 
            @blur="handleBlur(user.repeatPassword,'regsStatus02')" class="icon_password">
            <i slot="suffix" :class="repertFlag ? 'close_eye':'el-icon-view'" autocomplete="auto" @click="repertFlag=!repertFlag" />
            </el-input>
          </el-form-item>
           <el-form-item prop="verificationCode" v-if="hasSendPhoneCode == '1'" class="verificationCode">
            <div :class="{'signUpStyle':changeSyle.regsStatus10,signupComlabel:true}">
              <span class="tips">*</span> {{$t('register.phonecodePlace') }}
            </div>
            <el-input
              type="text"
              v-model="user.verificationCode"
              autocomplete="off" class="icon_vercode"
              :placeholder="changeSyle.regsStatus10 ? $t('register.verificationPlace') : '' " 
              @keyup.enter.native="submitForm('ruleForm')"
              @focus="handleFocus(user.verificationCode,'regsStatus10')" 
              @blur="handleBlur(user.verificationCode,'regsStatus10')"
              :disabled="isReady">
             <template  slot="suffix" :class="{'disabled':sending}">
                <el-button round @click.native="sendCode" :disabled="sending">{{$t(sendingTip)}}</el-button>
              </template>
            </el-input>
          </el-form-item>

            <!-- 自定义注册项 -->
          <template v-if="RegisterList_ && RegisterList_.length >0">
            <el-form-item v-for="item in RegisterList_" :key="item.id" v-show="!item.isShow" :prop="item.requireSwitch == 0 ? '' : item.typeName" :class="hasSendPhoneCode == '1' ?  item.typeName : ''">
              <div :class="{'signUpStyle':changeSyle[item.typeName],signupComlabel:true}"> 
                <span class="tips" v-show="item.requireSwitch != 0">*</span>
                {{$t('register')[item.typeName]}}
              </div>
              <el-input
                :maxlength="item.lengthMax"
                :minlength="item.lengthMin"
                type="text"
                v-model="user[item.typeName]"
                autocomplete="off"
                :class="hasSendPhoneCode == '1' ?  item.typeName : ''"
                :disabled="setIsDisabled(item)"
                :placeholder="changeSyle[item.typeName] ? $t('verificationRegister')[item.typeName] : '' "
                @keyup.enter.native="submitForm('ruleForm')"
                @focus="handleFocus(user[item.typeName],item.typeName)" 
                @blur="handleBlur(user[item.typeName],item.typeName)"
                >
                <!-- :placeholder="$t('register')[item.typeName] -->
                <!-- <span slot="prefix" >+91</span> -->
                <!-- <template slot="append">请输入手机号</template> -->
                <span v-if="hasSendPhoneCode == '1' && item.typeName == 'phone'" slot="prefix" >+91</span>
                <template v-if="hasSendPhoneCode == '1' && item.typeName == 'phone'" slot="suffix" :class="{'disabled':sending}">
                  <el-button round @click.native="sendCode" :disabled="sending">{{$t(sendingTip)}}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </template>
          
          <!-- <el-form-item>
            <div :class="{'signUpStyle':changeSyle.regsStatus09,signupComlabel:true}">
              {{$t('register.agent')}}</div>
            <el-input type="text" v-model="user.agentCode" autocomplete="off" :disabled="isReady || Boolean(this.$Cookies.get('agentCode'))"
            :placeholder="changeSyle.regsStatus09 ? $t('register.agent') : '' " 
            @keyup.enter.native="submitForm('ruleForm')" class="icon_referral"
            @focus="handleFocus(user.agentCode,'regsStatus09')" 
            @blur="handleBlur(user.agentCode,'regsStatus09')"
            >
            </el-input>
          </el-form-item> -->

          <el-form-item prop="verificationCode" v-if="hasSendPhoneCode != '1'">
            <div :class="{'signUpStyle':changeSyle.regsStatus10,signupComlabel:true}">
            <span class="tips">*</span>
              {{ $t('header.verification')}}
            </div>
            <el-input
              type="text"
              v-model="user.verificationCode"
              autocomplete="off" class="icon_vercode"
              :placeholder="changeSyle.regsStatus10 ? $t('register.verificationPlace') : '' " 
              @keyup.enter.native="submitForm('ruleForm')"
              @focus="handleFocus(user.verificationCode,'regsStatus10')" 
              @blur="handleBlur(user.verificationCode,'regsStatus10')"
              :disabled="isReady"
            >
              <template slot="suffix">
                <img :src="user.securityCodeSrc" @click="!isReady && getVifyCode()" style="margin-top:6px" />
                 <i  @click="!isReady && getVifyCode()" class="fresh_ico"></i>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="flex-button">
          <div class="RememberMe">
            <el-checkbox v-model="checked">{{$t('register.agree')}}</el-checkbox>
            <router-link to="/helpCenter/startUse?id=3&index=1" style="color:#323232;border-bottom:1px solid #323232">
              <span @click="setshowloginfloat(false)">{{$t('register.Terms')}}</span>
            </router-link>
          </div>
          <div class="btn-group">
            <el-button :loading="isReady" type="primary" @click="submitForm('ruleForm')" @keyup.enter.native="submitForm('ruleForm')" class="_reg_now">{{$t('header.signup')}}</el-button>
          </div>
        </div>
        <div class="Returnsignin" @click="gologin">{{$t('dialog.goLogin')}} <span style="color:#bebf01;">{{ $t('dialog.login')}}</span></div>
      </div>
    </div>

      <!--注册成功 -->
      <div class="reg-success" v-else>
        <p class="_title">{{ $t('createdDislaog.diaTitle') }}!</p>
        <div class="succ-image"><img src="../img/success_bg.png" alt width="100%" height="auto"/></div>
        <p class="despoit_btn" @click="handleDespoit">{{ $t('mine.capital.deposit') }}</p>
      </div>
    </dialogTem>
  </div>
</template>

<script>
import dialogTem from '../dialogTem.vue'
import languages from '../languages.vue'
import { mapState, mapActions, mapMutations } from "vuex";
import { check, common , commonApi , INcheck  } from "@/common/index";
// import { clearObject  } from '@/common/utils/index.js'
export default {
  components:{ languages,dialogTem },
  data() {
    let checkusername = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
      if (value === "") {
        let str = this.$t('login.userRules1');
        callback(new Error(str));
      } else if (!reg.test(value)) {
        let str = this.$t('register.userPlace');
        callback(new Error(str));
      } else {
        callback();
      }
    };
    let checkpassword = (rule, value, callback) => {
      let reg = /^[A-Za-z0-9]{6,12}$/;
      if (value === "") {
        let str = this.$t('login.passwordRules');
        callback(new Error(str));
      } else if (!reg.test(value)) {
        let str = this.$t('register.passwordPlace');
        callback(new Error(str));
      } else {
        callback();
      }
    };
    let checkrepeatPassword = (rule, value, callback) => {
      let reg = /^[A-Za-z0-9]{6,12}$/;
      if (value === "") {
        let str = this.$t('register.epeatPassword1');
        callback(new Error(str));
      } else if (this.user.repeatPassword !== this.user.password) {
        let str = this.$t('register.epeatPassword2');
        callback(new Error(str));
      } else {
        callback();
      }
    };
    // let checkphoneNumber = (rule, value, callback) => {
    //   let reg = /^\d{10}$/;
    //   if (value === "") {
    //     let str = this.$t('register.phoneNumber1');
    //     callback(new Error(str));
    //   } else if (!reg.test(value)) {
    //     let str = this.$t('register.phoneNumber2');
    //     callback(new Error(str));
    //   } else {
    //     callback();
    //   }
    // };
    let checkverificationCode = (rule, value, callback) => {
      if (value === "") {
        let str = this.$t('login.verificationRules');
        callback(new Error(str));
      } else {
        callback();
      }
    };

    let checkphoneNumber = (rule, value, callback) => {

          if(this.Register_phoneNumber?this.Register_phoneNumber.length>0?true:false:false){
             if (value === "" && this.Register_phoneNumber[0].requireSwitch == '1') {
                let str = this.$t('register.phoneNumber1')
                callback(new Error(str));
             } else if(value.length > this.Register_phoneNumber[0].lengthMax || value.length < this.Register_phoneNumber[0].lengthMin ){
                let str1 = this.$t('register.phoneRules');
                // let str2 = this.$t('register.allRules');
                // let str3 = this.$t('register.Bit');
                // str2+this.Register_phoneNumber[0].lengthMax+str3
                callback(new Error(str1+this.Register_phoneNumber[0].lengthMin));
              }else if(!/^[0-9]+$/.test(value)){
                callback(new Error(this.$t('register.phoneRules2')));
              }else{
                callback();
              }
          }

    };

    let checkQQ = (rule, value, callback) => {

          if(this.Register_qq?this.Register_qq.length>0?true:false:false){
             if (value === "" && this.Register_qq[0].requireSwitch == '1') {
                let str = this.$t('register.qqRules')
                callback(new Error(str));
              } else if(value.length > this.Register_qq[0].lengthMax || value.length < this.Register_qq[0].lengthMin ){
                let str1 = this.$t('register.qqRules2');
                let str2 = this.$t('register.allRules');
                let str3 = this.$t('register.Bit');
                callback(new Error(str1+this.Register_qq[0].lengthMin+str2+this.Register_qq[0].lengthMax+str3));
              }else {
                callback();
              }
          }

    };
    let checkrealName = (rule, value, callback) => {

          if(this.Register_realName?this.Register_realName.length>0?true:false:false){
            if (value === "" && this.Register_realName[0].requireSwitch == '1') {
              // callback(new Error($t('register.realNameRules')));
              let str = this.$t('register.realNameRules')
              callback(new Error(str));
            } else if(value.length > this.Register_realName[0].lengthMax || value.length < this.Register_realName[0].lengthMin ){
                let str1 = this.$t('register.realNameRules2');
                let str2 = this.$t('register.allRules');
                let str3 = this.$t('register.Bit');
              callback(new Error(str1+this.Register_realName[0].lengthMin+str3));
            }else {
              callback();
            }
          }

    };
    let checkwechat = (rule, value, callback) => {

          if(this.Register_wechat?this.Register_wechat.length>0?true:false:false){
            if (value === "" && this.Register_wechat[0].requireSwitch == '1') {
              let str = this.$t('register.realwxRules')
              callback(new Error(str));
            } else if(value.length > this.Register_wechat[0].lengthMax || value.length < this.Register_wechat[0].lengthMin ){
                let str1 = this.$t('register.realwxRules2');
                let str2 = this.$t('register.allRules');
                let str3 = this.$t('register.Bit');
              callback(new Error(str1+this.Register_wechat[0].lengthMin+str2+this.Register_wechat[0].lengthMax+str3));
            }else {
              callback();
            }
          }

    };
    let checkemail = (rule, value, callback) => {
      let reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;

          if(this.Register_email?this.Register_email.length>0?true:false:false){
            if (value === "" && this.Register_email[0].requireSwitch == '1') {
              let str = this.$t('register.emailRulse')
              callback(new Error(str));
            } else if(value.length > this.Register_email[0].lengthMax || value.length < this.Register_email[0].lengthMin ){
                let str1 = this.$t('register.emailRulse2');
                let str2 = this.$t('register.allRules');
                let str3 = this.$t('register.Bit');
              callback(new Error(str1+this.Register_email[0].lengthMin+str2+this.Register_email[0].lengthMax+str3));
            } else if (!reg.test(value)){
              let str = this.$t('register.emailRulse3')
              callback(new Error(str));
            }
            else {
              callback();
            }
          }

    };
    let checkwithdrawPassword = (rule, value, callback) => {

          if(this.Register_withdrawPassword?this.Register_withdrawPassword.length>0?true:false:false){
            if (value === "" && this.Register_withdrawPassword[0].requireSwitch == '1') {
              let str = this.$t('register.withdrawPasswordRules')
              callback(new Error(str));
            } else if(value.length > this.Register_withdrawPassword[0].lengthMax || value.length < this.Register_withdrawPassword[0].lengthMin ){
                let str1 = this.$t('register.withdrawPasswordRules2');
                let str2 = this.$t('register.allRules');
                let str3 = this.$t('register.Bit');
              callback(new Error(str1+this.Register_withdrawPassword[0].lengthMin+str2+this.Register_withdrawPassword[0].lengthMax+str3));
            }else {
              callback();
            }
          }

    };
    return {      
      timer:null,
      sendingTip:'register.sendingTip',
      sending: false,
      leftpx:'',
      flag:true,
      repertFlag:true,
      isShow2:false,
      RegisterList:'',
      user: {
        username: "",
        password: "",
        repeatPassword: "",
        phone: "",
        agentCode: "",
        domain: "",
        securityCodeSrc: "",
        timestamp: "",
        verificationCode: "",
        realName:'',
        qq:'',
        wechat:'',
        email:'',
        withdrawPassword:'',
      },
      checked: true,
      isShow: "password",
      isReady: false,
      rules: {
        agentCode: [
          { required: true, message:this.$t('login.agentCode'), trigger: 'blur' },
        ],
        username: [
          { validator: checkusername, trigger: "blur", required: true },
        ],
        password: [
          { validator: checkpassword, trigger: "blur", required: true },
        ],
        repeatPassword: [
          { validator: checkrepeatPassword, trigger: "blur", required: true },
        ],
        phone: [
          { validator: checkphoneNumber, trigger: "blur", required: true },
        ],
        qq: [
          { validator: checkQQ, trigger: "blur", required: true }
        ],
        realName: [
          { validator: checkrealName, trigger: "blur", required: true }
        ],
        wechat: [
          { validator: checkwechat, trigger: "blur", required: true }
        ],
        email: [
          { validator: checkemail, trigger: "blur", required: true }
        ],
        withdrawPassword: [
          { validator: checkwithdrawPassword, trigger: "blur", required: true }
        ],
        verificationCode: [
          {
            validator: checkverificationCode,
            trigger: "blur",
            required: true,
          },
        ],
      },
      changeSyle:{
        regsStatus:false,
        regsStatus01:false,
        regsStatus02:false,
        realName:false,
        qq:false,
        wechat:false,
        email:false,
        phone:false,
        withdrawPassword:false,
        agentCode:false,
        regsStatus10:false
      }
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      showloginfloat: (state) => state.showloginfloat,
      hasSendPhoneCode: state => state.linkList.hasSendPhoneCode,
      isPhoneVerify: state => state.linkList.isPhoneVerify,
    }),
    // 手机号
    Register_phoneNumber(){ 
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'phone')
      }
    },
    // 真实姓名
    Register_realName(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'realName')
      }
    },
    // qq
    Register_qq(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'qq')
      }
    },
    // 微信
    Register_wechat(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'wechat')
      }
    },
    // 电子邮箱
    Register_email(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'email')
      }
    },
    // 提款密码
    Register_withdrawPassword(){
      if(this.RegisterList.length>0){
        return  this.RegisterList.filter(item => item.typeName == 'withdrawPassword')
      }
    },
    // 自定义注册项
    RegisterList_(){
        let arr = this.RegisterList
        if(this.isPhoneVerify == '3' && arr ){
          arr.forEach((e,i) => {
            if(e.typeName == 'phone'){
              arr[i].isShow = true
            }else{
              arr[i].isShow = false
            }
          });
        }
        return arr
      }
  },
  watch: {
    showloginfloat(v) {
      if (v) {
        this.user.agentCode = this.$Cookies.get('agentCode') || ''
        if(this.user.agentCode) this.changeSyle.agentCode = true
      }
    },
  },
  methods: {
    setIsDisabled(item){
      if(item.typeName == 'agentCode') return this.isReady || Boolean(this.$Cookies.get('agentCode'))
      if(item.typeName == 'phone') return this.sending || this.isReady
      else return this.isReady
    },
    ...mapMutations(["setshowloginfloat", "setshowloginfloat2"]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "Login"]),
      handleFocus(ele,val){
      if(!ele){ this.changeSyle[val] = !this.changeSyle[val] }
    },
    handleBlur(ele,val){
      if(!ele){ this.changeSyle[val] = !this.changeSyle[val] }
    },
    gologin() {
      this.setshowloginfloat(false);
      this.setshowloginfloat2(true);
    },
    handleDespoit(){
      this.$router.push({path:'/mine/deposit'})
      this.setshowloginfloat(false);
    },
    _notify(message,title = this.$t('notify.warning'),type = 'warning'){ this.$notify({ title,message,type })},
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isReady = true;
          let params = {
            username: this.isPhoneVerify == '3' ? this.user.phone : this.user.username,
            password: this.user.password,
            repeatPassword: this.hasSendPhoneCode == 1 ? this.user.password : this.user.repeatPassword,
            phone: this.user.phone,
            agentCode: this.user.agentCode,
            timestamp: this.user.timestamp,
            regDomain: this.user.domain,
            vrifyCode: this.user.verificationCode,
            realName:this.user.realName,
            qq:this.user.qq,
            wechat:this.user.wechat,
            email:this.user.email,
            withdrawPassword:this.user.withdrawPassword,
            regType:this.hasSendPhoneCode == 1?'3':''
          };
          let isOK = this.checkForm();
          if (isOK) {
            this.$api.post(this.$urls.USER.REGISTER,params,(resp) => {
              if (resp.data.code === 200) {
                this.$store.dispatch('reportRegistration')
                this.$Cookies.remove('agentCode')
                // this.setshowloginfloat(false);
                this.$refs[formName].resetFields();
                this.isReady = false;
                let UUID = resp.data.data;
                this.$Cookies.set("UUID", UUID);
                this.Login(UUID);
                common.logedUserInfo();
                for (let key in this.user) this.user[key] = ''
                for (let key in this.changeSyle) this.changeSyle[key] = false
              }else{
                this.isReady = false;
                this.getVifyCode();
                this._notify(resp.data.msg,this.$t('notify.error'))
              }
            },(err) => { this.isReady = false;});
          } else { this.isReady = false; }
        } else { this._notify(this.$t('login.finishContent')) }
      });
    },
    checkForm() {
      let isOK = true;
      let msg = INcheck.INcheckRealname(this.user.username);
      let pwd = INcheck.checkRegisterPassword(this.user.password);
      let phone = INcheck.checkPhone(this.user.phone);
      let repeatMsg = INcheck.checkConfirm(
        this.user.password,
        this.user.repeatPassword
      );
      //检验账号
      if (msg && this.isPhoneVerify != '3') {
        this._notify(this.$t(msg))
        return isOK = false;
      }
      //校验密码
      if (pwd) {
        this._notify(this.$t(pwd))
        return isOK = false;
      }
     if(this.Register_phoneNumber?this.Register_phoneNumber.length>0?true:false:false){
        if(this.Register_phoneNumber[0].requireSwitch == '0' && this.user.phone){
          if(!/^\d{10}$/.test(this.user.phone)){
            this._notify(this.$t('form.checkPhone2'))
            return isOK = false;
          }
        }
      }
      // 邮箱
      if(this.Register_email?this.Register_email.length>0?true:false:false){
        if(this.Register_email[0].requireSwitch == '0' && this.user.email){
          if(!/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/.test(this.user.email)){
            this._notify(this.$t('register.emailRulse3'))
            return isOK = false;
          }
        }
      }
      // 密码确认
      if (repeatMsg && this.hasSendPhoneCode != 1) {
        this._notify(this.$t(repeatMsg))
        return isOK = false;
      }
      // 协议
      if (!this.checked) {
        this._notify(this.$t('register.pleaseRead'))
        return isOK = false;
      }
      if (this.user.verificationCode === "") {
        this._notify(this.$t('header.checkVrifyCode'))
        return isOK = false;
      }
      return isOK;
    },

    // 获取验证码
    getVifyCode() {
      this.vrifyCode = "";
      let randomStr = common.randomRange(16);
      let timer = Math.floor(Date.now() / 1000);
      this.user.securityCodeSrc = this.$urls.USER.REGISTERCODE + `?timestamp=${timer}` + randomStr;
      this.user.timestamp = timer + randomStr;
    },
    // 获取自定义注册项
    getRegisterList () {
      commonApi.HOMEBEFORE.getRegisterList().then(data => {
        this.RegisterList = data
      }).catch(err => { console.log(err) })
    },
    // 获取手机验证码
    sendCode() {
      if (!INcheck.checkPhone(this.user.phone)) {
        commonApi.CONFIRM.sendVerify({phoneNum: this.user.phone}).then((data) => {
          this.sending = true;
          this.countDown(60);
          this._notify(this.$t('register.Sentsuccessfully'),this.$t('notify.success'),'success')
        }).catch((err) => {
          this.sending = false;
          this._notify(err)
        })
      }else{  this._notify(this.$t(INcheck.checkPhone(this.user.phone))) }
    },
    // 倒計時
    countDown(Countdown) {
      this.timer = setInterval(() => {
        this.sendingTip = Countdown + 's'
        Countdown--;
        if (Countdown < 0) {
          clearInterval(this.timer);
          this.sending = false;
          this.sendingTip = this.$t('register.sendingTip')
        }
      }, 1000);
    },
  },
  mounted() {
    this.getVifyCode();
    this.getRegisterList();
    // this.user.domain = document.domain;
    // this.getAgentCode()
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
.registerFloat {
  .login-body { 
    padding:8px 22px 70px;
    .box-left{
      .el-form{
        display:flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .login{
          color: #fff;
          text-align: center;
          cursor: pointer;
          padding-bottom: 15px;
        }
        .el-form-item {
          width:48.6%;
          margin-bottom:10px!important;
        }
      }
      ._reg_now{ width:348px;margin-top:0;}
      .flex-button{
        display:flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .Returnsignin{ 
      color:#323232;
      text-align: center;
      margin-top:50px;
      cursor: pointer;
    }
  }
  .fresh_ico{
    display: inline-block; width: 19px; height: 20px; background: url(../img/fresh_ico.png) no-repeat; vertical-align: middle; cursor: pointer;
  }
  .reg-success{  // 注册成功
    padding-bottom:80px;
    text-align: center;
    ._title{
      font-family: Roboto-Black;
      font-size: 30px;
      color: #ffffff;
      font-weight: 800;
      margin-bottom:28px;
    }
    .succ-image{ width:91px;height:92px;margin:0 auto;}
    .despoit_btn{
      width: 336px;
      margin:50px auto 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      // background-image: linear-gradient(90deg,#80fbb4 0%,#c3fd7c 100%);
      background:#e2bf87;
      border-radius: 4px;
      font-weight: bold;
      cursor: pointer;
      font-family: Roboto-Black;
      font-size: 16px;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
.registerFloat{
  .el-input__inner {
    &::placeholder {
      color:#b1b1b1;
      font-size:13px;
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
      color: #b1b1b1;
    }

    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #b1b1b1;
    }

    &::-moz-placeholder {
        /* Mozilla Firefox 19+ 适配火狐 */
      color: #b1b1b1;
    }

    &:-ms-input-placeholder {
        /* Internet Explorer 10+  适配ie*/
      color: #b1b1b1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/common/register/register.vue